import { render, staticRenderFns } from "./taskResult.vue?vue&type=template&id=b5bb327a&scoped=true&"
import script from "./taskResult.vue?vue&type=script&lang=js&"
export * from "./taskResult.vue?vue&type=script&lang=js&"
import style0 from "./taskResult.vue?vue&type=style&index=0&id=b5bb327a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5bb327a",
  null
  
)

export default component.exports